

 
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ReactDOM from 'react-dom';
import axios from "axios";
import {
  FiShield, FiUser, FiLock, FiSettings, FiLogOut, FiBriefcase, FiChevronDown, FiHome
} from 'react-icons/fi';
import Config from "../config";
import '../css/Updatedstyles.css';
import { useAuthorization } from '../Manager/hooks/useAuthorizations';
import { logoutUser } from "./Logout";
 
const Navigationbar = ({ mode, toggleTheme, hideLinks = false }) => {
  const navigate = useNavigate();
  const { permissionLevel, loading: authLoading } = useAuthorization();
 
  const [menuItems, setMenuItems] = useState([]);
  const [role_id, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userEmployeeId, setUserEmployeeId] = useState("");
  const [userId, setUserId] = useState("");
  const [access_token, setAccessToken] = useState("");
  const [plantName, setPlantName] = useState("");
  const [allowedUrls, setAllowedUrls] = useState([]);
  const [error, setError] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
 
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [activeMenu, setActiveMenu] = useState(null);
  const menuItemRefs = useRef({});
  const menuRef = useRef(null);
  const profileRef = useRef(null);
 
  const roleMapping = {
    "1": "Service Provider", "2": "SuperAdmin", "3": "Admin", "4": "Initiator",
    "5": "Reviewer", "6": "Approver", "7": "ViewRole", "8": "Manager",
    "9": "Coordinator", "10": "User"
  };
 
  const homePageRoutes = {
    "1": "/ServiceProviderHome", "2": "/SuperAdminHome", "3": "/AdminHome",
    "4": "/InitiatorHome", "5": "/ReviewerHome", "6": "/ApproverHome",
    "7": "/Viewhome", "8": "/managers/dashboard", "9": "/hr/dashboard",
    "10": "/user/dashboard"
  };
 
  // useEffect(() => {
  //   const fetchPayload = async () => {
  //     try {
  //       const res = await fetch(`/sso/payload/`, {
  //         credentials: "include",
  //       });
  //       if (res.ok) {
  //         const data = await res.json();
  //         console.log(data,"SSSSSSSSSSSSSSSS")
  //         if (data?.payload) {
  //           const p = data.payload;
  //           setUserId(p.user_id);
  //           setRoleId(p.role_id);
  //           setUserFirstName(p.first_name);
  //           setUserLastName(p.last_name);
  //           setUserEmployeeId(p.employee_id);
  //           setAccessToken(p.access_token || "");
  //           setPlantName(p.plant_name || "");
  //           setAllowedUrls(p.allowed_urls || []);
  //           setRoleName(roleMapping[p.role_id] || "Unknown Role");
  //         }
  //       } else {
  //         setError("Failed to fetch payload data.");
  //         // navigate("/");
  //       }
  //     } catch (err) {
  //       console.error("Payload fetch failed", err);
  //       // navigate("/");
  //     }
  //   };
  //   fetchPayload();
  // }, [navigate]);
 
  useEffect(() => {
  const fetchPayload = async () => {
    try {
      const res = await axios.get(`/sso/payload/`, {
        withCredentials: true,
      });
      const data = res.data;
        console.log(data, "PAYLOAD DATA");
 
        if (data?.payload) {
          const p = data.payload;
 
          // ✅ USER DATA
          setUserId(p.user?.user_guid);
          setUserFirstName(p.user?.firstName);
          setUserLastName(p.user?.lastName);
 
          // ❌ role_id not available anymore
          // setRoleId(...)
 
          // ❌ employee_id not available
          // setUserEmployeeId(...)
 
          // ✅ CURRENT PLANT
          const currentPlant = p.plants?.find(
            (pl) => pl.plantUid === p.current_plant_uid
          );
 
          if (currentPlant) {
            setPlantName(currentPlant.plantName);
          }
 
          // ✅ OPTIONAL
          setAccessToken(""); // token is in cookie, no need usually
 
        }
    } catch (err) {
      console.error("Payload fetch failed", err);
      setError("Failed to fetch payload data.");
    }
  };
 
  fetchPayload();
}, []);
 
 
  useEffect(() => {
    if (!role_id) return;
    const fetchMenuData = async () => {
      try {
        const response = await axios.get(`${Config.BASE_URL}/api/features/${role_id}/`, {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
        const data = response.data;
        setMenuItems(data);
        const allowedUrlsList = data.flatMap(menu =>
          menu.subFeatures.map(sub =>
            `/${sub.text.toLowerCase().replace(/\s+/g, "-")}`
          )
        );
        await axios.post(`/api/store_allowed_urls/`,
          { allowed_urls: allowedUrlsList },
          {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
        const sessionResponse = await axios.get(`/api/payload/`, {
          withCredentials: true,
        });
        setAllowedUrls(sessionResponse.data.payload?.allowed_urls || []);
      } catch (error) {
        if (error?.response?.status === 403) {
          handleUnauthorized();
          return;
        }
        console.error("Error fetching menu:", error);
      }
    };
    fetchMenuData();
  }, [role_id]);
 
  const handleUnauthorized = async () => {
    try {
      await axios.post(`/api/terminate/`,
        { user_ids: userId },
        {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${access_token}`
        },
        withCredentials: true,
      });
    } catch (err) {
      console.error('Logout error:', err);
    }
    sessionStorage.clear();
    navigate("/");
  };
 
  const handleHomeClick = (e) => {
    e.preventDefault();
    const homePage = homePageRoutes[role_id] || "/dashboard";
    navigate(homePage);
  };
 
  const handleLogout = async () => {
    await logoutUser(navigate, {
      closeTab: true,
    });
  };
 
  const toggleDropdown = (id, event) => {
    event.preventDefault();
 
    if (activeDropdown === id) {
      setActiveDropdown(null);
      setActiveMenu(null);
    } else {
      const rect = event.currentTarget.parentNode.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
      setActiveDropdown(id);
      setActiveMenu(menuItems.find(menu => menu.id === id));
    }
  };
 
  const toggleProfile = () => {
    setIsProfileOpen(prev => !prev);
  };
 
  useEffect(() => {
    const handleClickOutside = (e) => {
      const isClickInsideMenu = Object.values(menuItemRefs.current).some(ref =>
        ref && ref.contains(e.target)
      );
 
      const dropdownElement = document.querySelector('[data-dropdown-portal="true"]');
      const isClickInsideDropdown = dropdownElement && dropdownElement.contains(e.target);
 
      if (!isClickInsideMenu && !isClickInsideDropdown) {
        setActiveDropdown(null);
        setActiveMenu(null);
      }
 
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setIsProfileOpen(false);
      }
    };
 
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const initials = userFirstName && userLastName
    ? `${userFirstName[0].toUpperCase()}${userLastName[0].toUpperCase()}`
    : "UD";
 
  const PortalDropdown = () => {
    if (!activeMenu || activeDropdown !== activeMenu.id) return null;
 
    return ReactDOM.createPortal(
      <ul
        data-dropdown-portal="true"
        style={{
          position: 'absolute',
          top: `${dropdownPosition.top}px`,
          left: `${dropdownPosition.left}px`,
          minWidth: activeMenu.text === "Admin" ? '' : '240px',
          width: 'max-content',
          maxWidth: '400px',
          margin: '8px 0 0 0',
          padding: '8px 0',
          background: 'var(--theme-accent)',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          border: '1px solid #e5e7eb',
          zIndex: 99999,
          listStyle: 'none',
          animation: 'dropdownFade 0.2s ease',
        }}
      >
        {activeMenu.subFeatures.map((sub) => {
          const route = `/${sub.text.toLowerCase().replace(/\s+/g, "-")}`;
 
          return (
            <li key={sub.id} style={{ margin: 0, padding: 0 }}>
              <Link
                to={route}
                onClick={() => {
                  setActiveDropdown(null);
                  setActiveMenu(null);
                }}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '10px 20px',
                  color: '#ffffff',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  whiteSpace: 'nowrap',
                  borderLeft: '3px solid transparent',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  background: 'none',
                  textAlign: 'left',
                  fontFamily: 'inherit'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                  e.currentTarget.style.borderLeftColor = '#3b82f6';
                  e.currentTarget.style.paddingLeft = '23px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderLeftColor = 'transparent';
                  e.currentTarget.style.paddingLeft = '20px';
                }}
              >
                {sub.text}
              </Link>
            </li>
          );
        })}
      </ul>,
      document.body
    );
  };
 
  return (
    <>
      <div className="navbar-container">
        <nav className="navbar" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '93px',
          padding: '0 24px',
          position: 'relative',
          transition: 'all 0.3s ease'
        }}>
          {/* Brand Section - Left */}
          <div className="brand-section" style={{
            display: 'flex',
            alignItems: 'center',
            flex: '0 0 auto'
          }}>
            <span className="brand-name" style={{
              fontSize: '28px',
              fontWeight: 1000,
              marginLeft: '90px',
              whiteSpace: 'nowrap'
            }}>
              Skillora
            </span>
          </div>
 
          {/* Menu List - CENTERED */}
          <ul
            ref={menuRef}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '32px',
              margin: 0,
              padding: 0,
              listStyle: 'none',
              flexDirection: 'row',
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          >
            <li style={{ position: 'static' }}>
              <a
                href="#"
                onClick={handleHomeClick}
                style={{
                  color: 'black',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '15px',
                  padding: '8px 0',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer'
                }}
              >
                {/* <FiHome size={20} />
                <span>Home</span> */}
              </a>
            </li>
            {menuItems.map((menu) => (
              <li
                key={menu.id}
                ref={el => menuItemRefs.current[menu.id] = el}
                style={{ position: 'static' }}
              >
                <a
                  href="#"
                  onClick={(e) => toggleDropdown(menu.id, e)}
                  style={{
                    color: 'black',
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: '15px',
                    padding: '8px 0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    cursor: 'pointer'
                  }}
                >
                  {menu.text}
                  {menu.subFeatures.length > 0 && (
                    <FiChevronDown
                      size={16}
                      style={{
                        transform: activeDropdown === menu.id ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.2s ease'
                      }}
                    />
                  )}
                </a>
              </li>
            ))}
          </ul>
 
          {/* Right Section: Profile */}
          <div className="right-section" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flex: '0 0 auto',
            width: '200px'
          }}>
            <div className="profile-wrapper" ref={profileRef} style={{ position: 'relative' }}>
              <button
                className="profile-button"
                onClick={toggleProfile}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  background: 'none',
                  border: 'none',
                  color: 'black',
                  cursor: 'pointer',
                  padding: '8px 12px',
                  borderRadius: '10px'
                }}
              >
                <div className="avatar" style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '10px',
                  background: 'linear-gradient(135deg, #A47AAB, #8B5CF6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: '14px',
                  color: 'white'
                }}>
                  {initials}
                </div>
                <div className="user-info hide-on-mobile" style={{ textAlign: 'left' }}>
                  <div className="user-name" style={{ fontSize: '14px', fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {userFirstName} {userLastName}
                  </div>
                  <div className="user-role" style={{ fontSize: '11px', opacity: 0.8, whiteSpace: 'nowrap' }}>
                    {plantName}
                  </div>
                </div>
                <FiChevronDown size={16} className="hide-on-mobile" />
              </button>
 
              {isProfileOpen && (
                <div className="profile-dropdown" style={{
                  position: 'absolute',
                  top: 'calc(100% + 8px)',
                  right: 0,
                  width: '280px',
                  backgroundColor: '#ffffff',
                  borderRadius: '14px',
                  boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
                  border: '1px solid #e5e7eb',
                  padding: '20px',
                  zIndex: 99999,
                  animation: 'dropdownFade 0.2s ease'
                }}>
                  {/* <Link
                    to="/changepassword"
                    onClick={() => setIsProfileOpen(false)}
                    className="profile-item"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '14px 16px',
                      borderRadius: '10px',
                      color: '#374151',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: 500,
                      marginBottom: '4px',
                      width: '100%',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      fontFamily: 'inherit'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f3f4f6';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'none';
                    }}
                  >
                    <FiLock className="profile-icon" style={{ fontSize: '18px', width: '24px' }} />
                    <span>Change Password</span>
                  </Link> */}
 
                  <Link
                    to="/ChangePlant"
                    onClick={() => setIsProfileOpen(false)}
                    className="profile-item"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '14px 16px',
                      borderRadius: '10px',
                      color: '#374151',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: 500,
                      marginBottom: '4px',
                      width: '100%',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      fontFamily: 'inherit'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f3f4f6';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'none';
                    }}
                  >
                    <FiBriefcase className="profile-icon" style={{ fontSize: '18px', width: '24px' }} />
                    <span>Change Plant</span>
                  </Link>
 
                  <button
                    onClick={() => setShowLogoutModal(true)}
                    className="profile-item"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '14px 16px',
                      borderRadius: '10px',
                      color: '#374151',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: 500,
                      marginBottom: '4px',
                      width: '100%',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      fontFamily: 'inherit'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f3f4f6';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'none';
                    }}
                  >
                    <FiLogOut className="profile-icon" style={{ fontSize: '18px', width: '24px' }} />
                    <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
 
      {/* PORTAL DROPDOWN */}
      <PortalDropdown />
 
      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="logout-modal" style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 20000
        }}>
          <div
            className="modal-content"
            style={{
              width: '400px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              background: 'white',
              borderRadius: '20px',
              padding: '40px',
              boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2)',
              border: '1px solid #e5e7eb'
            }}
          >
            <img
              src="/images/queMark.png"
              alt="Warning"
              style={{ width: 60, height: 60, marginBottom: 16 }}
            />
            <h2 className="modal-title" style={{
              color: 'black',
              textAlign: 'center',
              fontSize: '20px',
              fontWeight: 700,
              marginBottom: '30px'
            }}>
              Are You Sure to Logout?
            </h2>
            <div className="modal-buttons" style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center'
            }}>
              <button
                className="btn-negative"
                onClick={() => setShowLogoutModal(false)}
                style={{
                  padding: '12px 32px',
                  borderRadius: '12px',
                  background: 'transparent',
                  border: '2px solid #e5e7eb',
                  color: '#374151',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                No
              </button>
              <button
                className="btn"
                onClick={handleLogout}
                style={{
                  padding: '12px 32px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #FF6B6B, #FF4757)',
                  color: 'white',
                  fontWeight: 600,
                  cursor: 'pointer',
                  border: 'none'
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
 
      <style>{`
        @keyframes dropdownFade {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};
 
export default Navigationbar;
 
 
 
